import { useEffect } from 'react';
import { getIsPrerenderUserAgent } from '../../utils/userAgent';

interface PrerenderReadyProps {
  ready?: boolean;
  statusCode?: number;
}

export default function PrerenderReady({ ready = true }: PrerenderReadyProps) {
  const prerenderReady = ready && getIsPrerenderUserAgent();

  useEffect(() => {
    if (prerenderReady) {
      (window as any).prerenderReady = true;
      return () => {
        (window as any).prerenderReady = false;
      };
    }
    return () => {};
  }, [prerenderReady]);

  return null;
}
